export default __webpack_public_path__ + "static/media/judge-asks.51b7a33e.png";